// Components
import Button from '@/components/global-components/Button';

// Themes
import theme from '@/themes/index';

const SimpleBanner = ({
  content: {
    title,
    description = '',
    primaryButton,
  },
}) => {
  return (
    
    <>
      <div className="simple-banner">
        <h2 className="simple-banner__title">{title}</h2>
        {description &&
        <p className="simple-banner__description">{description}</p>
        }
        
        <Button
          className="primary"
          text={primaryButton.title}
          href={primaryButton.url}
          tabIndex={0}
          width="8.25rem"
          styles={{
            margin: '2rem auto 0', 
          }}
        />
      </div>
      <style jsx>{`


        .simple-banner  {
          background-color: ${theme.backgroundColors.primary};
          color: ${theme.fontColors.primary};
          width: 100%;
          padding: 3rem 5rem;
          border-top: ${theme.backgroundColors.neutral} 1px solid;
          border-bottom: ${theme.backgroundColors.neutral} 1px solid;
        }

        .simple-banner .simple-banner__title,
        .simple-banner .simple-banner__description {
          text-align: center;
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0;
          margin-inline-end: 0;
        }

        .simple-banner .simple-banner__title {
          font-family: ${theme.fontFamilies.montserratBold};
          font-size: 1.5rem;
          line-height: 2rem;
        }

  
        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          .simple-banner  {
            padding: 7.5em 4rem;
          }

          .simple-banner .simple-banner__title {
            font-size: 2.3rem;
            line-height: 2.5rem;
          }
        }


      `}</style>
    </>
  );
};

export default SimpleBanner;
